// extracted by mini-css-extract-plugin
module.exports = {"a6kdr01":"a6kdr01","anue-service":"anue-service"};